require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Symbol['for'];



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/symbol/for.js
// module id = 129
// module chunks = 0